export default "/images/vendor/flag-icon-css/flags/4x3/je.svg?cc06b8c75e723221fb6fc6df60c7fd68";